export default "__VITE_ASSET__Cw8SO_w4__"